module.exports = __webpack_public_path__ + "a6819159c3d9df0e4ec55f0a8f969595.autumn.svg";